import {Dispatch} from "redux";
import {v4 as uuid} from "uuid";
import {Alert} from "../components/modules/alert.model";
import {AlertTypes} from "@leap4/frontend";

const SET_ALERT = "SET_ALERT";
const REMOVE_ALERT = "REMOVE_ALERT";

export const setAlert =
    (msg: string, type: AlertTypes = AlertTypes.WARNING, timeout = 5000) =>
        (dispatch: Dispatch) => {
            const id = uuid();
            dispatch({
                type: SET_ALERT,
                payload: new Alert(id, type, msg),
            });

            setTimeout(() => dispatch({type: REMOVE_ALERT, payload: id}), timeout);
        };
